import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import { prepareFeaturesToDisplay, formatRating } from './helpers'

import classes from './TopFeatures.module.scss'

/** @type {import("./types").default} */
const TopFeatures = ({ className, listing, uniqueFeatures = [], align }) => {
  const featuresToDisplay = prepareFeaturesToDisplay(listing.top_features, uniqueFeatures)
  const hasFeaturesToDisplay = featuresToDisplay.length > 0

  return (
    <div className={clsx('TopFeatures', classes.root, className)}>
      {hasFeaturesToDisplay ? (
        featuresToDisplay.map(feature => (
          <div
            className={clsx(classes.row, {
              [classes.alignRight]: align === 'right',
              [classes.alignLeft]: align === 'left',
            })}
            key={feature.id}
          >
            <Typography variant="tight-xs" className={classes.featureName}>
              {feature.name}
            </Typography>

            <Typography variant="tight-xs">
              {feature.avg_rating ? `${formatRating(feature.avg_rating)}/5` : 'N/A'}
            </Typography>
          </div>
        ))
      ) : (
        <div>
          <Typography className={clsx(classes.nameWithRating, classes.disabled)} variant="tight-xs">
            No unique features
          </Typography>
        </div>
      )}
    </div>
  )
}

export default TopFeatures
